var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.className },
    [
      _c(
        "swiper",
        {
          attrs: { config: _vm.config, pagination: true },
          on: {
            init: _vm.init,
            startNext: _vm.startNext,
            startPrev: _vm.startPrev,
          },
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm._l(_vm.contentList, function (content, index) {
            return _c("swiper-slide", { key: index }, [
              _c("div", { staticClass: "rb-pdp-lens-panel_carousel__item" }, [
                _c(
                  "div",
                  { staticClass: "rb-pdp-lens-panel_carousel__item__title" },
                  [
                    _vm._v(
                      "\n          " + _vm._s(content.title) + "\n        "
                    ),
                  ]
                ),
              ]),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("progress", {
        staticClass: "rb-pdp-navigation__progress",
        attrs: { max: _vm.contentList.length },
        domProps: { value: _vm.current + 1 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }